export default {
  MuiIconButton: {
    styleOverrides: {
      root: {
        padding: '0px'
      }
    }
  }
};
